import {ReactNode, useCallback, useEffect, useState} from 'react';

import {Conversation} from '@stripe-internal/conversations-client';
import {Log} from '@stripe-internal/conversations-ui';

import {isMessageInteractivityEnabled} from '../lib/util/conversationUtils';
import {useConversationLogEvents} from '../../StripeAssistant/hooks/useConversationLogEvents';
import {useRestartConversationEvents} from '../../StripeAssistant/hooks/useRestartConversationEvents';

type Props = {
  conversation: Conversation;
  topContent?: ReactNode;
};

export function AssistantLog({conversation, topContent}: Props) {
  useConversationLogEvents(conversation);
  useRestartConversationEvents();

  return (
    <AssistantLogContent conversation={conversation} topContent={topContent} />
  );
}

export function AssistantLogContent({conversation, topContent}: Props) {
  const [disableMessageInteractivity, setDisableMessageInteractivity] =
    useState<boolean>(!isMessageInteractivityEnabled(conversation));

  const bindToConversationState = useCallback(() => {
    setDisableMessageInteractivity(
      !isMessageInteractivityEnabled(conversation),
    );
  }, [conversation]);

  useEffect(() => {
    bindToConversationState();
  }, [bindToConversationState]);

  return (
    <Log
      conversation={conversation}
      animated
      disableInteraction={disableMessageInteractivity}
      topContent={topContent}
    />
  );
}
